import React from "react";
import { t } from "ttag";

import { ButtonSecondary } from "../Clickables";

import headerStyles from "./Header.module.scss";
import styles from "./SkipLink.module.scss";

export const SkipLink = () => (
    <ButtonSecondary
        href={`#${headerStyles.mainContentId}`}
        className={styles.skipLink}
    >
        {t`Skip to main content`}
    </ButtonSecondary>
);
